import { fromJS, List, Map } from 'immutable';
import queryString from 'query-string';
import {APP_NAMES, CHANGED, ERROR, FORM_HIDE, FORM_SHOW, REMOVE, START, SUCCESS} from '../../consts';
import { LOCATION_CHANGE } from '../../utils/reducers/routerReducer';
import {
  ANNOUNCEMENT_COUNT_LOAD,
  ANNOUNCEMENT_LOAD,
  FILTER_RESET,
  FILTER_UPDATE,
  SEARCH_FILTER,
  SUBSCRIPTION,
  AGENCIES_LOAD,
  AUTOCOMPLETE_UPDATE,
} from './actionTypes';
import { COMMENT } from '../Comments/actionTypes';
import { DEFAULT_BASE_FILTER, DEFAULT_EXTEND_FILTER, DEFAULT_FILTER } from './filter';
import { parseAliasQuery } from '../../utils/aliases';

export const BASE_STATE_FILTER = DEFAULT_BASE_FILTER;
export const DEFAULT_STATE_EXTEND_FILTER = DEFAULT_EXTEND_FILTER;
export const DEFAULT_STATE_FILTER = DEFAULT_FILTER;

export const DEFAULT_STATE = fromJS({
  loading: 0,
  loaded: false,
  error: null,
  filteredOfferCount: 0,
  formSearchFilter: new Map({
    open: false,
    loading: false,
    error: null
  }),
  formSubscriptionSearchFilter: new Map({
    open: false,
    loading: false,
    error: null
  }),
  filter: DEFAULT_STATE_FILTER,
  announcementList: new List(),
  meta: {
    seoTitle: '',
    seoDescription: ''
  },
  agenciesList: new List(),
  selectedOptions: new List(),
});

export default function search (state = DEFAULT_STATE, action) {
  switch (action.type) {
    // обновление урла
    case LOCATION_CHANGE:
      const locationFilter = locationReducer(state.get('filter'), action);
      return state.setIn(['filter'], locationFilter);

    // обновление фильтра
    case FILTER_RESET:
    case FILTER_UPDATE:
      const filter = filterReducer(state.get('filter'), action);
      return state.mergeIn(['filter'], filter);

    // загрузка объявлений
    case ANNOUNCEMENT_LOAD + START:
      return state.merge({
        loading: state.get('loading') + 1,
        error: null
      });
    case ANNOUNCEMENT_LOAD + SUCCESS:
      return state.merge({
        filteredOfferCount: action.meta.get('totalCount', 0) || 0,
        loading: state.get('loading') - 1,
        loaded: true,
        announcementList: action.items,
        meta: action.meta
      });
    case ANNOUNCEMENT_LOAD + ERROR:
      return state.merge({
        loading: state.get('loading') - 1,
        loaded: false,
        announcementList: new List(),
        error: action.payload
      });
    case ANNOUNCEMENT_COUNT_LOAD + SUCCESS:
      return state.merge({
        filteredOfferCount: action.count
      });

    // загрузка агенств
    case AGENCIES_LOAD + START:
      return state.merge({
        loading: state.get('loading') + 1,
        error: null
      });
    case AGENCIES_LOAD + SUCCESS:
      return state.merge({
        agenciesList: action.items,
        loading: state.get('loading') - 1,
      });
    case AGENCIES_LOAD + ERROR:
      return state.merge({
        loading: state.get('loading') - 1,
        agenciesList: new List(),
        error: action.payload
      });

    // обновление автокомплита
    case AUTOCOMPLETE_UPDATE:
      return state.merge({
        selectedOptions: action.payload
      });

    // сохранить поиск
    case SEARCH_FILTER + START:
    case SEARCH_FILTER + SUCCESS:
    case SEARCH_FILTER + ERROR:
      const formFilter = filterFormReducer(state.get('formSearchFilter'), action);
      return state.mergeIn(['formSearchFilter'], formFilter);

    // подписаться на фильтр
    case SUBSCRIPTION + START:
    case SUBSCRIPTION + SUCCESS:
    case SUBSCRIPTION + ERROR:
      const formSubscriptionFilter = filterFormReducer(state.get('formSubscriptionSearchFilter'), action);
      return state.mergeIn(['formSubscriptionSearchFilter'], formSubscriptionFilter);

    // редактирование комментариев
    case COMMENT + REMOVE:
      const rmAnnouncementList = state.get('announcementList');
      return state.set('announcementList', rmAnnouncementList.map(item => {
        if (item.get('id') === action.payload) {
          return item.set('comments', fromJS([]));
        } else {
          return item;
        }
      }));
    case COMMENT + CHANGED:
      const realtyId = action.payload.realtyId;
      const chAnnouncementList = state.get('announcementList');

      return state.set('announcementList', chAnnouncementList.map(item => {
        if (item.get('id') === realtyId) {
          return item.set('comments', fromJS([action.payload]));
        } else {
          return item;
        }
      }));
    default:
      return state;
  }
}

function locationReducer (state = DEFAULT_STATE_FILTER, action) {
  const location = fromJS(action.payload || {});
  let query = parseAliasQuery(location.get('pathname'), APP_NAMES.search);
  return query.merge(queryString.parse(location.get('search')));
}

/**
 * Reducer для фильтра недвижимости
 * @param state
 * @param action
 * @returns {*}
 */
function filterReducer (state = DEFAULT_STATE_FILTER, action) {
  switch (action.type) {
    case FILTER_RESET:
      return DEFAULT_STATE_FILTER;
    case FILTER_UPDATE:
      return state.merge(action.payload);
    default:
      return state;
  }
}

function filterFormReducer (state, action) {
  switch (action.type) {
    case SEARCH_FILTER + START:
    case SUBSCRIPTION + START:
      return state.merge({
        loading: true,
        error: null
      });
    case SEARCH_FILTER + SUCCESS:
    case SUBSCRIPTION + SUCCESS:
      return state.merge({
        loading: false,
        error: null
      });
    case SEARCH_FILTER + ERROR:
    case SUBSCRIPTION + ERROR:
      return state.merge({
        loading: false,
        error: action.payload
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/Search/reducer.js